import request from '@/axios';

export const getPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/device/page',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDispositionPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/device/disposition',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/emp-data-center/emp-data/device/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const update = (row) => {
  return request({
    url: '/emp-data-center/emp-data/device/update',
    method: 'post',
    data: row
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/device/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/emp-data-center/emp-data/device/save',
    method: 'post',
    data: row
  })
}

export const getProtocolList = (params) => {
  return request({
    url: '/blade-system/dict-biz/dictionary',
    method: 'get',
    params
  })
}

export const updateGatewayStatus = (row) => {
  return request({
    url: '/emp-data-center/emp-data/device/updateStatus',
    method: 'post',
    params: row
  })
}

export const moveGatewayNode = (params) => {
  return request({
    url: '/emp-data-center/emp-data/device/moveNode',
    method: 'get',
    params
  })
}
export const updateDeviceStatus = (row) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/updateStatus',
    method: 'post',
    params: row
  })
}


// table B
export const getItemList = (params) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/itemlist',
    method: 'get',
    params
  })
}
export const getItemPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const devicePage = (current, size, params) => {
  return request({
    url: '/emp-business/billing/meterUser/devicePage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const associatedDevicePage = (current, size, params) => {
  return request({
    url: '/emp-business/billing/meterUser/associatedDevicePage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const getItemDetail = (id) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const updateItem = (row) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/update',
    method: 'post',
    data: row
  })
}

export const itmeRemove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}
export const saveItem = (row) => {
  return request({
    url: '/emp-data-center/emp-data/deviceRtu/save',
    method: 'post',
    data: row
  })
}
